export const withoutDecimals = (amount: number) => Number(amount.toFixed(0));
